import React, { useState } from "react";
import { Stack } from "@mui/material";
import { connect } from "react-redux";

import { getUserLocation } from "../../redux/auth";
import { useGetScheduleThroughput } from "../../hooks/react-query/useScheduleData";
import { PagePrint } from "../../components";
import { ThroughputTable } from "../../tables";

import ScheduleBar from "./ScheduleBar";
import { MODE_THROUGHPUT } from "./dateHelper";
import { StyledHubButtonGroup } from "./styles";

const modes = [
  { id: "complete", label: "Planned End", icon: "Calendar" },
  { id: "ship", label: "Planned Ship", icon: "Calendar" },
  { id: "finished", label: "Complete", icon: "Archive" },
];

const Throughput = ({ defaultLocation = 1 }) => {
  const [mode, setMode] = useState("complete");

  const { data, isLoading } = useGetScheduleThroughput({
    defaultLocation,
    mode,
  });

  return (
    <Stack width="100%" height="100%" overflow="hidden">
      <ScheduleBar mode={MODE_THROUGHPUT} hideTabs useExport>
        <StyledHubButtonGroup
          buttons={modes}
          selected={mode}
          setSelected={setMode}
          buttonProps={{ variant: "outlined" }}
          allowNeutral
        />
      </ScheduleBar>

      <Stack flex={1} overflow="auto" padding="15px">
        <PagePrint id="throughput-print" noPageStyle flip>
          <ThroughputTable
            weeks={data?.weeks}
            customers={data?.customers}
            weekTotals={data?.weekTotals}
            weekHealth={data?.weekHealth}
            mode={mode}
            isLoading={isLoading}
          />
        </PagePrint>
      </Stack>
    </Stack>
  );
};

const mapStateToProps = (state) => ({
  defaultLocation: getUserLocation(state),
});

export default connect(mapStateToProps)(Throughput);
